enum PlanInterval {
	Daily = "Daily",

	Weekly = "Weekly",

	Monthly = "Monthly"
}

export default PlanInterval;
